import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AprovacaoDeProjetos from '.';
import AprovacaoDeParcelamentosDoSoloUrbano from './AprovacaoDeParcelamentosDoSoloUrbano';
import DownloadsMapaDeLocalizacao from './AprovacaoDeParcelamentosDoSoloUrbano/DownloadsMapaDeLocalizacao';
import DownloadsSeloDeProjetos from './AprovacaoDeParcelamentosDoSoloUrbano/DownloadsSeloDeProjetos';

function Media() {
	return (
		<Switch>
			<Route
				exact
				path="/media/aprovacao-de-projetos"
				component={AprovacaoDeProjetos}
			/>

			<Route
				exact
				path="/media/aprovacao-de-projetos/parcelamentos-do-solo-urbano/mapa-de-localizacao"
				component={DownloadsMapaDeLocalizacao}
			/>
			<Route
				exact
				path="/media/aprovacao-de-projetos/parcelamentos-do-solo-urbano/selo-de-projetos"
				component={DownloadsSeloDeProjetos}
			/>
			<Route
				path="/media/aprovacao-de-projetos/parcelamentos-do-solo-urbano"
				component={AprovacaoDeParcelamentosDoSoloUrbano}
			/>
		</Switch>
	);
}

export default Media;
